var map = {
	"./Coinbase.svg": 14746,
	"./Lock-1.png": 74724,
	"./faq.svg": 58215,
	"./logOut.svg": 35657,
	"./metamask.svg": 5088,
	"./notify.svg": 28800,
	"./referral.svg": 35107,
	"./settings.png": 22097,
	"./settings.svg": 69530,
	"./wallet.svg": 23219,
	"./walletconnect.svg": 74649
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 44140;